import axios from 'axios'

export const apiV1 = axios.create({
  baseURL: process.env.END_POINT
})

export const apiV2 = axios.create({
  baseURL: process.env.GATEWAY_V2_END_POINT
})

export const buildAxiosRequestConfig = payload => {
  const {
    url,
    method,
    params,
    headers,
    data,
    token,
    organisationId
  } = payload

  if(
    !url ||
    !method
  ) {
    throw new Error('Missing some payload request params {url, method ...}')
  }

  const axiosRequestConfig = {
    url,
    method,
    params: {},
    headers: {}
  }

  if(params) {
    axiosRequestConfig['params'] = params
  }

  if(organisationId) {
    axiosRequestConfig['params'] = {
      ...axiosRequestConfig['params'],
      organisationId
    }
  }

  if(headers) {
    axiosRequestConfig['headers'] = headers
  }

  if(data) {
    axiosRequestConfig['data'] = data
  }

  if (token.token) {
    axiosRequestConfig.headers = {
      ...headers,
      Authorization: `Bearer ${token.token}`
    }
  } else if (token.isCareAuthenticated) {
    const postFixPath = url.split('/').slice(3).join('/')
    axiosRequestConfig.withCredentials = true
    axiosRequestConfig.url = `https://api.qa.app.khoros.com/v1/flow/${postFixPath}`
  }

  return axiosRequestConfig
}